import { FormCard } from '@qbe/ads-blocks-forms';
import { Button, Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

import logo from '~/assets/images/ProductReview.com.au.png';
import { config } from '~/config';
import { useAppContent } from '~/hooks';

import { StarsLink } from './StarsLink';

export const ProductReviewPanel = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.confirmation' });
  const link = config.endpoints.productReview.url;

  return (
    <FormCard variant="sectionTitle" title={getTextContent('feedbackfeefo.text.title')}>
      <Typography align="center">{getTextContent('feedbackfeefo.text.description')}</Typography>
      <Spacer size="md" />
      <img style={{ width: '12rem ' }} src={logo} alt="Feefo" />
      <Spacer size="sm" />
      <StarsLink link={link} />
      <Spacer size="md" />
      <Button
        href={link}
        target="_blank"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        rel="noopener noreferrer"
        component="a"
        data-track={getTextContent('buttons.rateUsNow')}
        label={getTextContent('buttons.rateUsNow')}
      />
    </FormCard>
  );
};
